import React, { Fragment } from "react";
import { Container, Grid, Typography } from "@mui/material";
import richmond from "../Assets/richmondmap.jpg";
import whitton from "../Assets/whitton.jpg";
import { Link } from "react-router-dom";
const ContactUs = () => {
  return (
    <Fragment>
      <Container>
        <Grid container spacing={4} sx={{ display: "flex", py: 5, mb: 10 }}>
          <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
            <img
              src={richmond}
              alt="map"
              style={{ width: "100%", maxWidth: "30rem", marginLeft: "auto" }}
            />
            <Typography variant="h4" component="h2" sx={{ my: 3 }}>
              Richmond Branch
            </Typography>
            <Typography sx={{ fontWeight: "bold" }} variant="h6">
              Address:
            </Typography>
            <Typography>
              16 Richmond Hill, Richmond, TW10 6QX
              <br />
              <br />
            </Typography>
            <Typography>
              <Link to={"tel:02036633293"} target="blank">
                Tel: 020 3663 3293
              </Link>
              <br />
              {/* Fax: 020 3632 1468 */}
              {/* <br /> */}
              Email: info@faamgallery.com
              <br />
              <br />
            </Typography>
            <Typography sx={{ fontWeight: "bold" }} variant="h6">
              Opening Hours:
            </Typography>
            <Typography
              sx={{ textAlign: "left", maxWidth: "18rem", mx: "auto" }}
            >
              <Grid container>
                <Grid item xs={6}>
                  Monday
                </Grid>
                <Grid item xs={6}>
                  10:00am - 5:00pm
                </Grid>
                <Grid item xs={6}>
                  Tuesday
                </Grid>
                <Grid item xs={6}>
                  10:00am - 5:00pm
                </Grid>
                <Grid item xs={6}>
                  Wednesday
                </Grid>
                <Grid item xs={6}>
                  Closed
                </Grid>
                <Grid item xs={6}>
                  Thursday
                </Grid>
                <Grid item xs={6}>
                  10:00am - 5:00pm
                </Grid>
                <Grid item xs={6}>
                  Friday
                </Grid>
                <Grid item xs={6}>
                  10:00am - 5:00pm
                </Grid>
                <Grid item xs={6}>
                  Saturday
                </Grid>
                <Grid item xs={6}>
                  10:00am - 5:00pm
                </Grid>
                <Grid item xs={6}>
                  Sunday
                </Grid>
                <Grid item xs={6}>
                  Closed
                </Grid>
              </Grid>
            </Typography>
            <br />
            <br />
            <Typography sx={{ fontWeight: "bold" }} variant="h6">
              Public Transport:
            </Typography>
            <Typography>
              Bus: Richmond Hill / The Vineyard Stop – approx. 2–4 min walk
              <br /> (Served by routes including 371, 65 & N65)
              <br />
              <br />
              Train & Underground: Richmond Station – approx. 10–12 min walk
              <br />
              (Overground, South Western Railway & District Line services)
              <br />
              <br />
            </Typography>
            <Typography sx={{ fontWeight: "bold" }} variant="h6">
              Parking:
            </Typography>
            <Typography>
              Paid parking available along Richmond Hill and surrounding streets
              <br />
              (subject to local restrictions and event times).
              <br />
              <br />
            </Typography>
            <Typography>
              Nearby public parking options available within central Richmond.
              It is recommended to check local parking signage upon arrival.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
            <img
              src={whitton}
              alt="map"
              style={{ width: "100%", maxWidth: "30rem", marginLeft: "auto" }}
            />
            <Typography variant="h4" component="h2" sx={{ my: 3 }}>
              Whitton Branch
            </Typography>
            <Typography sx={{ fontWeight: "bold" }} variant="h6">
              Address:
            </Typography>
            <Typography>
              131 Percy Road, Whitton, TW2 6HT <br />
              <br />
            </Typography>
            <Typography>
              <Link to={"tel:02036321468"} target="blank">
                Tel: 020 3632 1468
              </Link>
              <br />
              {/* Fax: 020 3632 1468 */}
              {/* <br /> */}
              Email: info@faamgallery.com
              <br />
              <br />
            </Typography>
            <Typography sx={{ fontWeight: "bold" }} variant="h6">
              Opening Hours:
            </Typography>
            <Typography
              sx={{ textAlign: "left", maxWidth: "18rem", mx: "auto" }}
            >
              <Grid container>
                <Grid item xs={6}>
                  Monday
                </Grid>
                <Grid item xs={6}>
                  09:30am - 5:30pm
                </Grid>
                <Grid item xs={6}>
                  Tuesday
                </Grid>
                <Grid item xs={6}>
                  09:30am - 5:30pm
                </Grid>
                <Grid item xs={6}>
                  Wednesday
                </Grid>
                <Grid item xs={6}>
                  Closed
                </Grid>
                <Grid item xs={6}>
                  Thursday
                </Grid>
                <Grid item xs={6}>
                  09:30am - 5:30pm
                </Grid>
                <Grid item xs={6}>
                  Friday
                </Grid>
                <Grid item xs={6}>
                  09:30am - 5:30pm
                </Grid>
                <Grid item xs={6}>
                  Saturday
                </Grid>
                <Grid item xs={6}>
                  10:30am - 5:30pm
                </Grid>
                <Grid item xs={6}>
                  Sunday
                </Grid>
                <Grid item xs={6}>
                  Closed
                </Grid>
              </Grid>
            </Typography>
            <br />
            <br />
            <Typography sx={{ fontWeight: "bold" }} variant="h6">
              Public Transport:
            </Typography>
            <Typography>
              Bus: Whitton Station Stop 1 min walk
              <br /> (Served by routes including H22 & 110)
              <br />
              <br />
              Train station: Whitton Railway station 1 min walk
              <br />
              <br /> <br />
            </Typography>
            <Typography sx={{ fontWeight: "bold" }} variant="h6">
              Parking:
            </Typography>
            <Typography>
              Free street parking after 2pm on Jubilee Ave and Montrose Ave
              <br />
              (except during event days)
              <br />
              <br />
            </Typography>
            <Typography>
              Paid parking bays on Jubilee Ave (3 spaces) and Montrose Ave (3
              spaces)
              <br />
              {/* 30min: 65p | 60min: £1.25 | 90min: £1.85 */}
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Fragment>
  );
};

export default ContactUs;
